import "./Header.scss";
import {Container, Grid, Image} from "semantic-ui-react";
import {Link} from "react-router-dom";
import logo from "../../assets/png/instaclone.png";
import RightHeader from "./RightHeader";

export default function Header() {
  return (
   <div className="header">
        <Container>
            <Grid>
                <Grid.Column width={3} className="header__logo">
                    <Link to="/">
                        <Image src={logo} alt="InstaClone" />
                    </Link>
                </Grid.Column>
                <Grid.Column width={10} className="header__search">
                    <p>Search</p>
                </Grid.Column>
                <Grid.Column width={3} className="header__menu">
                    <RightHeader />
                </Grid.Column>

            </Grid>
        </Container>
   </div>
        
  );
}